import React, { useRef, useState } from "react";
import { MdClear } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

const Input = ({
  value,
  onChange,
  placeholder,
  name,
  required,
  type,
  label,
  isInvalidInput,
  disabled,
  helper,
  onBlur,
  maxLength,
  removeBtn,
  bgWhite,
  endIcon,
  autoComplete,
  border,
  className,
  ...props
}) => {
  const ref = useRef();
  const [inputType, setInputType] = useState(type || "text");
  const { i18n } = useTranslation();
  return (
    <div className={`w-full flex flex-col gap-2 ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className={
            required
              ? "after:content-['*'] after:text-red-500 text-sm"
              : "text-sm"
          }
        >
          {label}
        </label>
      )}
      <div className="flex flex-col w-full relative">
        <input
          ref={ref}
          {...props}
          onBlur={onBlur}
          type={inputType}
          required={required}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          className={`py-3 lg:p-[18px] xl:px-[20px] xl:py-[12px] text-[12px] lg:text-[15px] text-black font-medium leading-normal rounded-full flex-shrink-0 bg-lightSilver ${border ? "border" : "border-none"} outline-none px-5 placeholder:text-[12px] ${
            bgWhite ? "bg-white" : ""
          } ${
            isInvalidInput && "text-[red] bg-[#fecaca]"
          } disabled:text-black disabled:bg-graytext ${
            i18n.dir() === "ltr"
              ? "placeholder:text-left"
              : "placeholder:text-right"
          }`}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          autoComplete={autoComplete || "new-off"}
        />
        {endIcon && endIcon}
        {type === "password" && (
          <button
            tabIndex={-1}
            className={`cursor-pointer absolute bg-none border-none flex justify-center items-center left-[5px] top-0 bottom-0 ${
              i18n.dir() === "ltr" ? "right-[5px] left-[unset] pr-2.5" : "pl-2.5"
            }`}
            type="button"
            onClick={() => {
              setInputType(inputType === "password" ? "text" : "password");
            }}
          >
            {inputType === "password" ? (
              <IoIosEye size={"24px"} color="#F04124" />
            ) : (
              <IoIosEyeOff size={"24px"} color="#F04124" />
            )}
          </button>
        )}

        {type !== "password" && value?.length > 0 && removeBtn && (
          <button
            tabIndex={-1}
            className={`cursor-pointer absolute bg-none border-none flex justify-center items-center left-[5px] top-0 bottom-0 pl-2.5 ${
              i18n.dir() === "ltr" ? "right-[5px] left-[unset]" : ""
            }`}
            type="button"
            onClick={() => {
              onChange({
                target: {
                  value: "",
                  name: name,
                },
              });
            }}
          >
            <MdClear size={"20px"} />
          </button>
        )}
      </div>
      <>{helper}</>
    </div>
  );
};

export default Input;
